import React, { useEffect, useState } from 'react'
import { Modal, Radio } from 'antd'
import './style.less'
import { SyncOutlined } from '@ant-design/icons'
import { ITaxYear } from '../ComplianceReports/types'
import { accessOptions } from '../../lib/enums'
import { httpPut } from '../../services/http'

export default function ChangeAdvisorAccessModal({
    visible,
    setVisible,
    taxYear,
    loadOverviewData,
}: {
    taxYear: ITaxYear
    visible: boolean
    setVisible: (isV: boolean) => void,
    loadOverviewData: (i?: string) => Promise<ITaxYear[]>,
}) {
    const [loadingSubmit, setLoadingSubmit] = useState<boolean>(false)
    const [accessValue, setAccessValue] = useState<string>(taxYear.advisor_scopes)

    useEffect(() => {
        setAccessValue(taxYear.advisor_scopes)
    }, [taxYear.advisor_scopes])

    const handleCancel = () => {
        setVisible(false)
    }

    async function handleAccessChange(newValue) {
        setLoadingSubmit(true)
        await httpPut(`/ll-user-to-advisor/${taxYear.id}/advisor-access/${taxYear.advisor_id}`, {
            scopes: newValue.target.value,
        })
        await loadOverviewData()
        setAccessValue(newValue.target.value)
        setLoadingSubmit(false)
    }

    const LoadingComp = <SyncOutlined style={{ fontSize: 20 }} spin />

    return (
        <>
            <Modal
                destroyOnClose
                visible={visible}
                title={'Change advisor access'}
                footer={[]}
                onCancel={handleCancel}
            >
                <p>
                    Changing access will take effect immediately.
                </p>
                {loadingSubmit && (
                    <>
                        {LoadingComp}
                        <br />
                        <br />
                    </>
                )}
                <Radio.Group
                    options={accessOptions}
                    onChange={handleAccessChange}
                    value={accessValue}
                    disabled={loadingSubmit}
                    optionType="button"
                    buttonStyle="solid"
                    size="small"
                />
            </Modal>
        </>
    )
}
